import React from "react";
import { useLocation } from "react-router-dom";
import { RouteErrorBoundary, type RouteErrorBoundaryProps } from "./RouteErrorBoundary";

/** RouteErrorBoundary that clears its error when the route's path or query changes. */
export const LocationErrorBoundary: React.FC<Omit<RouteErrorBoundaryProps, "resetKey">> = (props) => {
  const { pathname, search } = useLocation();
  return <RouteErrorBoundary {...props} resetKey={`${pathname}${search}`} />;
};

export default LocationErrorBoundary;
